import { Input } from "@comps/ui/input";
import { FieldFormatSectionProps } from "./FieldFormatSection";
import { TW_FieldFormatSectionLine, TW_FieldFormatSectionLine_Label, TW_FieldFormatSectionLine_Select, TW_FieldFormatSectionLine_TextInput } from "@utils/twClasses";
import { useTranslation } from "react-i18next";
import { DEFAULT_NUMBER_FORMAT } from "@utils/constants";
import { FieldType } from "@dto/fields";
import { NUMBER_FORMATS } from "@utils/types";


export function NumberFieldFormatSection({ fieldType, format, onFormatChange }: FieldFormatSectionProps) {

    const { t } = useTranslation();

    const numberFormat = (format && format.get("numberFormat")) ? format.get("numberFormat") : DEFAULT_NUMBER_FORMAT;
    const decimalPlaces = (format && format.get("decimalPlaces")) ? format.get("decimalPlaces") : "";

    return (
        <>
            <div className={TW_FieldFormatSectionLine}>
                <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.decimal.numberFormat.label")}</p>
            
                <select className={TW_FieldFormatSectionLine_Select} value={numberFormat} onChange={onFormatChange("numberFormat", false)}>
                    {Array.from(NUMBER_FORMATS).map(([key, value]) => {
                        let i18nKey = "number.format.description." + key;
                        if (fieldType === FieldType.Number) {
                            i18nKey += ".NUMBER";
                        }
                        return <option key={"number-format-" + key} value={value} className="text-base">{t(i18nKey)}</option>
                    })}
                </select>
            </div>

            {fieldType !== FieldType.Number && (
                <div className={TW_FieldFormatSectionLine}>
                    <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.decimal.decimalPlaces.label")}</p>
                    <Input className={TW_FieldFormatSectionLine_TextInput + " w-10"} pattern="\d*" placeholder="2" value={decimalPlaces} onChange={onFormatChange("decimalPlaces", false)} />
                </div>
            )}
        </>
    )
}
